(function () {
  var SCALE_MAX_MULTIPLIER = 1;

  function handles() {
    var el = document.getElementById('mixbar-handles');
    if (!el) return null;
    try {
      return new Set(JSON.parse(el.textContent));
    } catch (e) {
      return null;
    }
  }

  function countMedia(cart, set) {
    if (!set) return 0;
    return cart.items.reduce(function (n, it) {
      return set.has(it.handle) ? n + it.quantity : n;
    }, 0);
  }

  function message(n, t1q, t1p, t2q, t2p) {
    if (n >= t2q) return t2p + '% off applied to your whole mix';
    if (n >= t1q) {
      var left = t2q - n;
      return t1p + '% off applied. Add ' + left + ' more for ' + t2p + '%';
    }
    var need = t1q - n;
    if (n === 0) return 'Add ' + need + ' items for ' + t1p + '% off';
    if (n === 1) return 'This item is in. Add ' + need + ' more for ' + t1p + '% off';
    return 'Add ' + need + ' more for ' + t1p + '% off';
  }

  function paint(bar, n) {
    var t1q = +bar.dataset.t1Qty,
      t1p = +bar.dataset.t1Pct,
      t2q = +bar.dataset.t2Qty,
      t2p = +bar.dataset.t2Pct;
    var pct = Math.min(n / (t2q * SCALE_MAX_MULTIPLIER), 1) * 100;
    var fill = bar.querySelector('[data-mixbar-fill]');
    var blob = bar.querySelector('[data-mixbar-blob]');
    fill.style.width = pct + '%';
    blob.style.left = n ? 'calc(' + pct + '% - 13px)' : '-13px';
    blob.classList.toggle('is-empty', !n);
    blob.classList.toggle('is-active', n >= t1q);
    bar.querySelector('[data-mixbar-msg]').textContent = message(n, t1q, t1p, t2q, t2p);
    bar.classList.toggle('is-tier1', n >= t1q && n < t2q);
    bar.classList.toggle('is-tier2', n >= t2q);
  }

  function apply(cart) {
    var set = handles();
    var n = countMedia(cart, set);
    var bars = document.querySelectorAll('[data-mixbar]');
    if (!bars.length) return;
    bars.forEach(function (bar) {
      paint(bar, n);
    });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(apply)
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', refresh);
  if (document.readyState !== 'loading') refresh();

  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    return origFetch.apply(this, args).then(function (res) {
      try {
        var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) setTimeout(refresh, 250);
      } catch (e) {}
      return res;
    });
  };

  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('mixsave:added', refresh);
})();
